import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, signal, computed } from "@angular/core";
import { Item } from "../../pojo/Item";
import { S25ItemI } from "../../pojo/S25ItemI";
import { S25ItemModule } from "./s25.item.module";
import { S25FavoriteModule } from "../s25-favorite/s25.favorite.module";
import { S25ItemBean } from "./s25.item.component";
import { S25Util } from "../../util/s25-util";

@Component({
    selector: "s25-ng-item-list",
    template: `
        <ul>
            @for (item of typedItems(); track item.itemId) {
                <li>
                    <s25-item [modelBean]="item" [itemTypeId]="itemType"></s25-item>
                </li>
            }
        </ul>
    `,
    styles: [],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [S25ItemModule, S25FavoriteModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25ItemListComponent {
    @Input({ required: true }) items = signal<S25ItemI[]>([]);
    @Input({ required: true }) itemType: Item.Id;

    typedItems = computed(() => this.items().map(this.s25ItemIToBean));

    /**
     * Converts an S25ItemI to an S25ItemBean, mapping common fields generically.
     */
    s25ItemIToBean(item: S25ItemI): S25ItemBean {
        return {
            itemId: S25Util.parseInt(item.itemId),
            itemTypeId: item.itemTypeId,
            itemName: item.itemName || item.txt,
            itemLabel: item.itemDesc,
            isPrivate: S25Util.toBool(item.favorite),
            isInactive: !!item.isPermanent,
            includeTypeIcon: undefined,
            startDt: item.startDt,
            itemId2: item.reservation_id || item.reservationId,
            isImage: item.isImage,
            data: item.data,
            reservation_id: item.reservation_id,
            reservationId: item.reservationId,
            formalName: item.formalName,
            formal_name: item.formal_name,
            // Copy any other properties
            ...item,
        } as S25ItemBean;
    }
}
